export default __webpack_public_path__ + "static/media/Homescreen-02.c98f4f7a.jpg";